import { api_get, api_post } from '@/utils/http'
import { HREF, NPOST } from '@/utils/net-work'

const baseUri = '/search/api'

// 试卷列表
function getPaperAnalysisList(params: any) {
  return NPOST(baseUri + '/paper_analysis/paper/search', params)
}

// 学校接口
function getSchoolInfos(params: any) {
  return api_post(baseUri + '/paper_analysis/school/list', params)
}

// 获取左侧菜单栏
function paperAnalysisClassify(params: any) {
  return api_get(baseUri + '/paper_analysis/paper/classify', params)
}

// 所选试卷列表
function paperAnalysisList(params: any) {
  return NPOST(baseUri + '/paper_analysis/paper/list', params)
}

// 试卷分析-知识点结果展示
function paperAnalysisMenu(params: any) {
  return NPOST(baseUri + '/paper_analysis/menu', params)
}

// 题目列表
function paperAnalysisQuestionList(params: any) {
  return NPOST(baseUri + '/paper_analysis/question-list', params)
}

// 题目图表
function paperAnalysisCharts(params: any) {
  return NPOST(baseUri + '/paper_analysis/charts', params)
}

// 导出
function paperAnalysisChartDownload(params: any) {
  return HREF(baseUri + '/paper_analysis/download/chart', params)
}

// 题目详情
function paperAnalysisQuestionsDetail(params: any) {
  return NPOST(baseUri + '/paper_analysis/questions/detail', params)
}

// 试卷详情
function paperAnalysisDetail(params: any) {
  return NPOST(baseUri + '/paper_analysis/paper/detail', params)
}

// 试卷展开详情
function singleQuestionDetail(params: any) {
  return NPOST(baseUri + '/paper_analysis/single_question/detail', params)
}

// 保存用户选择的试卷
function postUserSelectedPapers(params: any) {
  return NPOST(baseUri + '/paper_analysis/user_selected/papers', params)
}

// 获取用户选择的试卷
function getUserSelectedPapers(params: any) {
  return api_get(baseUri + '/paper_analysis/user_selected/papers', params)
}

export {
  getPaperAnalysisList,
  getSchoolInfos,
  paperAnalysisClassify,
  paperAnalysisList,
  paperAnalysisMenu,
  paperAnalysisQuestionList,
  paperAnalysisCharts,
  paperAnalysisChartDownload,
  paperAnalysisQuestionsDetail,
  paperAnalysisDetail,
  singleQuestionDetail,
  postUserSelectedPapers,
  getUserSelectedPapers
}
